module.exports = __webpack_public_path__ + "img/vetar-parcialmente.58002399.png";